import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'

import OrderStatistics from "@pages/FinanceManagement/OrderStatistics/index";// 订单统计
import RefundStatistics from "@pages/FinanceManagement/RefundStatistics/RefundStatistics"; //退款数据统计

import PaymentCheckIn from "@pages/FinanceManagement/PaymentCheckIn/index";
import PaymentCheckInRecord from "@pages/FinanceManagement/PaymentCheckIn/record";  //来款记录
import PaymentCheckOut from "@pages/FinanceManagement/PaymentCheckOut/index"; // 扣减登记
import PaymentCheckOutRecord from "@pages/FinanceManagement/PaymentCheckOut/record";
import CustomerBalance from "@pages/FinanceManagement/CustomerBalance";//客户余额
import CustomerBalanceDetail from "@pages/FinanceManagement/CustomerBalance/detail";//客户余额明细

import RetroactivePayment from "@pages/FinanceManagement/RetroactivePayment/RetroactivePayment"; //催尾款 页面有问题不触发菜单切换，后面改掉
import RefundConfirmation from "@pages/FinanceManagement/refundConfirmation/RefundConfirmation"; // 退款确认
class FinanceRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/financeManagement/OrderStatistics" component={OrderStatistics} />
                <Route path="/financeManagement/paymentCheckIn-record" component={PaymentCheckInRecord} />
                {/* 退款确认 */}
                <Route path="/financeManagement/refundConfirmation" component={RefundConfirmation} />

                <Route path="/financeManagement/paymentCheckIn" component={PaymentCheckIn} />
                <Route path="/financeManagement/refundStatics" component={RefundStatistics} />
                <Route path="/financeManagement/paymentCheckOut" component={PaymentCheckOut} />

                <Route path="/financeManagement/paymentCheckOut-record" component={PaymentCheckOutRecord} />
                <Route path="/financeManagement/customerBalance" component={CustomerBalance} />
                <Route path="/financeManagement/customerBalanceDetail" component={CustomerBalanceDetail} />
                <Route path="/financeManagement/retroactivePayment" component={RetroactivePayment} />
                <Route path="/*" render={(props) => <Redirect to="/financeManagement/OrderStatistics" />} />
            </Switch>
        );
    }
}
export default FinanceRouter;